export enum Toast {
  error = 'toast-error',
  success = 'toast-success',
}
